import "./profile_checklist.scss";
import { useMemo, useState } from "react";
import { Body } from "@sprout/typography.tsx";
import useTranslation from "@hooks/use_translation.ts";
import useProfile from "@/queries/use_profile.ts";
import { useDashboardPreview } from "@components/dashboard/preview_context.tsx";
import LoadingSpinner from "@sprout/loading_spinner.tsx";
import { IconButton } from "@sprout/icon_button.tsx";
import ArrowUpIcon from "@sprout/icons/arrow_up.tsx";
import ArrowDownIcon from "@sprout/icons/arrow_down.tsx";
import { buildChecklistItems } from "@components/dashboard/profile/profile_checklist_items.ts";
import ProfileChecklistRow from "@components/dashboard/profile/profile_checklist_row.tsx";
import ProfileChecklistModal from "@components/dashboard/profile/modals/profile_checklist_modal.tsx";

const ProfileChecklist = () => {
  const { t } = useTranslation("user", { keyPrefix: "profile_checklist" });
  const { preview } = useDashboardPreview();
  const { data, isLoading } = useProfile({ mock: preview });
  const [expanded, setExpanded] = useState(true);
  const [openKey, setOpenKey] = useState<string | null>(null);
  const items = useMemo(() => (data ? buildChecklistItems(data) : []), [data]);

  if (isLoading || !data) {
    return (
      <div className="profile_checklist">
        <div className="flex justify-center">
          <LoadingSpinner size="small" />
        </div>
      </div>
    );
  }

  const completeCount = items.filter((item) => item.status === "complete").length;

  return (
    <div className="profile_checklist">
      <div className="profile_checklist__header">
        <div className="profile_checklist__header-title">
          <Body metadata medium>
            {t("title")}
          </Body>
          <Body metadata medium>
            •
          </Body>
          <Body metadata secondary>
            {t("completed", { count: completeCount, total: items.length })}
          </Body>
        </div>
        <IconButton
          icon={expanded ? ArrowUpIcon : ArrowDownIcon}
          size="md"
          label={t(expanded ? "collapse" : "expand")}
          onClick={() => setExpanded((value) => !value)}
        />
      </div>
      {expanded && (
        <ul className="profile_checklist__rows">
          {items.map((item) => (
            <ProfileChecklistRow
              key={item.key}
              item={item}
              t={t}
              onEdit={() => setOpenKey(item.key)}
            />
          ))}
        </ul>
      )}
      {!preview && (
        <ProfileChecklistModal
          openKey={openKey}
          onOpenChange={(isOpen) => !isOpen && setOpenKey(null)}
          data={data}
        />
      )}
    </div>
  );
};

export default ProfileChecklist;
